export default {
  namespaced: true,

  state: {
    id: null,
    token: null,
  },

  getters: {
    id: state => {
      return state.id;
    },

    token: state => {
      return state.token;
    },

    get: state => {
      return state;
    },
  },

  mutations: {
    setId: (state, id) => {
      state.id = id;
    },
    setToken: (state, token) => {
      state.token = token;
    },
  },

  actions: {
    init({dispatch}) {
      dispatch('initId');
      dispatch('initToken');
    },

    initId({commit}) {
      try {
        commit('setId', window.ShopifyAnalytics.meta.page.customerId || null);
      } catch (e) {}
    },

    initToken({commit}) {
      try {
        commit('setToken', window.ShopifyAnalytics.lib.user().traits().uniqToken);
      } catch (e) {}
    },
  },
};
